import styled from "@emotion/styled";

export const Item = styled.li`
  -webkit-tap-highlight-color: transparent;

  padding: 14px;

  font-size: 16px;
  font-weight: ${p => p.theme.fontWeight.medium};
  color: ${({ theme }) => theme.colors.secondary.main};
  border-radius: ${({ theme }) => theme.radii.normal};

  cursor: pointer;

  transition:
    color 0.3s ease-in-out,
    background-color 0.3s ease-in-out;

  :hover {
    color: ${({ theme }) => theme.colors.black};
    background-color: ${({ theme }) => theme.colors.background};
  }

  @media screen and (min-width: ${p => p.theme.screenSizes.mdMax}) {
    padding: ${({ theme }) => theme.space[5]}px;

    font-size: ${p => p.theme.fontSizes.m};
  }
`;
